export enum LicenseAssignment {
  EXCHANGE_CONNECTOR = 'EXCHANGE_CONNECTOR',
  WORK_4_ALL_MOBILE = 'WORK_4_ALL_MOBILE',
  WORK_4_ALL_MOBILE_LITE = 'WORK_4_ALL_MOBILE_LITE',
  WEB_ZEITERFASSUNG = 'WEB_ZEITERFASSUNG',
  NUR_ZEITERFASSER = 'NUR_ZEITERFASSER',
  WORK_4_ALL_MOBILE_PROF = 'WORK_4_ALL_MOBILE_PROF',
  KOMMT_GEHT = 'KOMMT_GEHT',
  TICKET_SYSTEM = 'TICKET_SYSTEM',
  LAGERSCANNER = 'LAGERSCANNER',
  WORK_4_ALL_MOBIL_2020 = 'WORK_4_ALL_MOBIL_2020',
  API = 'API',
  DESKTOP_CLIENT = 'DESKTOP_CLIENT',
  DO_NOT_USE = 'DO_NOT_USE',
  CRM_LIGHT = 'CRM_LIGHT',
  ERP_LIGHT = 'ERP_LIGHT',
  PROJEKT_LIGHT = 'PROJEKT_LIGHT',
  ARBEITSZEITERFASSUNG_LIGHT = 'ARBEITSZEITERFASSUNG_LIGHT',
  PROJEKTZEITERFASSUNG_LIGHT = 'PROJEKTZEITERFASSUNG_LIGHT',
  REISEKOSTENABRECHNUNG_LIGHT = 'REISEKOSTENABRECHNUNG_LIGHT',
  TICKETS_LIGHT = 'TICKETS_LIGHT',
}
